export const categories = [
  { slug: 'tian-douhua', name: '甜豆花', icon: 'ri-cake-line', description: '甜蜜滋润的传统甜豆花，搭配各类糖水与配料' },
  { slug: 'xian-douhua', name: '咸豆花', icon: 'ri-bowl-line', description: '鲜香浓郁的咸味豆花，融入各地特色调味' },
  { slug: 'tese-douhua', name: '特色豆花', icon: 'ri-star-line', description: '创意融合的现代豆花，打破传统边界的新口味' },
  { slug: 'bingzhen-douhua', name: '冰镇豆花', icon: 'ri-snowy-line', description: '清凉爽口的夏日豆花甜品，消暑解渴最佳选择' },
];

export const articles = [
  {
    id: '1',
    slug: 'jingdian-hongtang-douhua',
    title: '经典红糖姜汁豆花',
    category: 'tian-douhua',
    categoryName: '甜豆花',
    image: 'https://readdy.ai/api/search-image?query=Warm%20traditional%20Chinese%20tofu%20pudding%20douhua%20with%20brown%20sugar%20and%20ginger%20syrup%20in%20a%20ceramic%20bowl%2C%20soft%20silky%20texture%2C%20steaming%20hot%2C%20minimalist%20wooden%20table%20setting%20with%20warm%20ambient%20light%2C%20food%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20clean%20cream%20background&width=800&height=600&seq=douhua-recipe-01&orientation=landscape',
    excerpt: '红糖的温润与姜汁的辛辣完美融合，搭配嫩滑细腻的手工豆花，是冬日里最温暖的一碗甜蜜。',
    difficulty: '简单',
    prepTime: '30分钟',
    servings: '2人份',
    ingredients: [
      '黄豆 200g', '清水 1500ml', '内酯 3g', '红糖 60g',
      '老姜 30g', '枸杞 10g', '红枣 5颗',
    ],
    steps: [
      '将黄豆提前浸泡8小时，泡发至两倍大',
      '泡好的黄豆加入1500ml清水，用豆浆机打成生豆浆',
      '将生豆浆过滤去渣，倒入锅中大火煮沸，转中小火煮5分钟',
      '内酯用少量温水化开，倒入保温容器中',
      '将煮好的豆浆从高处冲入保温容器，静置15分钟凝固',
      '老姜切片，与红糖、红枣、枸杞一同加水煮15分钟制成糖水',
      '将凝固好的豆花舀入碗中，淋上红糖姜汁即可享用',
    ],
    tips: '冲豆浆时尽量从高处倒入，这样豆花口感更加细腻嫩滑。',
  },
  {
    id: '2',
    slug: 'sichuan-mala-douhua',
    title: '四川麻辣豆花',
    category: 'xian-douhua',
    categoryName: '咸豆花',
    image: 'https://readdy.ai/api/search-image?query=Sichuan%20style%20spicy%20savory%20tofu%20pudding%20douhua%20topped%20with%20chili%20oil%2C%20minced%20meat%2C%20green%20onions%2C%20and%20sesame%20seeds%20in%20a%20dark%20ceramic%20bowl%2C%20rustic%20wooden%20table%2C%20warm%20lighting%2C%20appetizing%20food%20photography%2C%20clean%20neutral%20background&width=800&height=600&seq=douhua-recipe-02&orientation=landscape',
    excerpt: '麻辣鲜香的四川风味咸豆花，嫩滑豆花配上香辣肉臊，花椒的麻与辣椒的香在口中交织，让人欲罢不能。',
    difficulty: '中等',
    prepTime: '45分钟',
    servings: '2人份',
    ingredients: [
      '黄豆 200g', '清水 1500ml', '内酯 3g', '猪肉末 100g',
      '豆瓣酱 20g', '花椒粉 5g', '辣椒油 15ml', '生抽 10ml',
      '榨菜 30g', '葱花 适量', '香菜 适量', '蒜末 10g',
    ],
    steps: [
      '黄豆提前浸泡8小时，打成豆浆过滤，煮开后加入内酯凝固成豆花',
      '锅中热油，放入猪肉末炒至变色',
      '加入豆瓣酱炒出红油，放入蒜末爆香',
      '加入生抽、少量清水，小火炖煮5分钟制成肉臊',
      '榨菜切碎备用',
      '将豆花舀入碗中，浇上麻辣肉臊',
      '撒上榨菜碎、葱花、香菜，淋上辣椒油和花椒粉即可',
    ],
    tips: '豆瓣酱要炒出红油才够香，花椒粉建议现磨风味更佳。',
  },
  {
    id: '3',
    slug: 'mocha-douhua',
    title: '抹茶红豆豆花',
    category: 'tese-douhua',
    categoryName: '特色豆花',
    image: 'https://readdy.ai/api/search-image?query=Matcha%20green%20tea%20flavored%20tofu%20pudding%20douhua%20with%20sweet%20red%20beans%20and%20mochi%20topping%2C%20elegant%20Japanese%20fusion%20dessert%20in%20a%20beautiful%20ceramic%20bowl%2C%20minimalist%20light%20wood%20table%2C%20soft%20natural%20light%2C%20clean%20cream%20background%2C%20editorial%20food%20photography&width=800&height=600&seq=douhua-recipe-03&orientation=landscape',
    excerpt: '日式抹茶与传统豆花的创意邂逅，清苦的抹茶搭配甜蜜红豆，层次丰富，颜值与美味并存。',
    difficulty: '简单',
    prepTime: '35分钟',
    servings: '2人份',
    ingredients: [
      '黄豆 200g', '清水 1500ml', '内酯 3g', '抹茶粉 15g',
      '蜜红豆 80g', '炼乳 30ml', '白玉丸子 4颗', '薄荷叶 少许',
    ],
    steps: [
      '黄豆浸泡、打浆、煮制、凝固成基础豆花',
      '抹茶粉用少量热水调成抹茶液',
      '将抹茶液混入豆浆中，搅拌均匀后再凝固',
      '豆花凝固后呈现淡绿色',
      '将抹茶豆花舀入碗中',
      '铺上蜜红豆，摆上白玉丸子',
      '淋上炼乳，点缀薄荷叶即可',
    ],
    tips: '抹茶粉品质直接影响成品颜色和风味，建议使用日式抹茶。',
  },
  {
    id: '4',
    slug: 'mango-coconut-douhua',
    title: '芒果椰奶冰豆花',
    category: 'bingzhen-douhua',
    categoryName: '冰镇豆花',
    image: 'https://readdy.ai/api/search-image?query=Chilled%20mango%20coconut%20tofu%20pudding%20douhua%20dessert%20with%20fresh%20mango%20cubes%2C%20coconut%20milk%20%20drizzle%2C%20and%20sago%20pearls%20in%20a%20glass%20bowl%2C%20tropical%20summer%20vibe%2C%20bright%20natural%20lighting%2C%20clean%20white%20background%2C%20fresh%20food%20photography&width=800&height=600&seq=douhua-recipe-04&orientation=landscape',
    excerpt: '热带芒果与香浓椰奶的完美组合，搭配冰凉嫩滑的豆花，是夏日消暑的绝佳甜品选择。',
    difficulty: '简单',
    prepTime: '25分钟',
    servings: '2人份',
    ingredients: [
      '黄豆 200g', '清水 1500ml', '内酯 3g', '芒果 1个',
      '椰浆 100ml', '西米 50g', '冰糖 40g', '薄荷叶 少许',
    ],
    steps: [
      '制作基础豆花，凝固后放入冰箱冷藏2小时',
      '西米煮至透明，过冷水备用',
      '芒果去皮切丁，一半打成芒果泥',
      '椰浆加冰糖小火加热至冰糖融化，放凉',
      '将冰镇豆花舀入碗中',
      '铺上芒果丁和西米',
      '淋上芒果泥和椰浆，点缀薄荷叶即可',
    ],
    tips: '豆花冷藏后口感更佳，椰浆不要加热太久以免油水分离。',
  },
  {
    id: '5',
    slug: 'guiyuan-hongzao-douhua',
    title: '桂圆红枣养生豆花',
    category: 'tian-douhua',
    categoryName: '甜豆花',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20tofu%20pudding%20douhua%20with%20dried%20longan%2C%20red%20dates%2C%20and%20goji%20berries%20in%20a%20warm%20amber%20syrup%2C%20elegant%20ceramic%20bowl%20with%20traditional%20pattern%2C%20soft%20warm%20lighting%2C%20clean%20cream%20background%2C%20comforting%20food%20photography&width=800&height=600&seq=douhua-recipe-05&orientation=landscape',
    excerpt: '精选桂圆、红枣、枸杞等传统滋补食材，搭配嫩滑豆花，暖身养颜，老少皆宜的养生佳品。',
    difficulty: '简单',
    prepTime: '40分钟',
    servings: '3人份',
    ingredients: [
      '黄豆 200g', '清水 1500ml', '内酯 3g', '桂圆干 30g',
      '红枣 10颗', '枸杞 15g', '冰糖 50g', '莲子 20g',
    ],
    steps: [
      '莲子提前浸泡2小时，桂圆干、红枣洗净备用',
      '制作基础豆花备用',
      '锅中加水，放入红枣、桂圆干、莲子煮20分钟',
      '加入冰糖和枸杞，再煮5分钟',
      '将豆花舀入碗中',
      '浇上煮好的桂圆红枣糖水即可',
    ],
    tips: '红枣去核后更容易煮出甜味，莲子不要煮太烂保持口感。',
  },
  {
    id: '6',
    slug: 'haisi-xiangcong-douhua',
    title: '海丝香葱豆花',
    category: 'xian-douhua',
    categoryName: '咸豆花',
    image: 'https://readdy.ai/api/search-image?query=Savory%20Chinese%20tofu%20pudding%20douhua%20topped%20with%20dried%20shrimp%2C%20seaweed%20shreds%2C%20green%20onions%2C%20and%20soy%20sauce%20in%20a%20traditional%20ceramic%20bowl%2C%20rustic%20wooden%20table%2C%20warm%20morning%20light%2C%20clean%20neutral%20background%2C%20authentic%20Chinese%20breakfast&width=800&height=600&seq=douhua-recipe-06&orientation=landscape',
    excerpt: '经典台式咸豆花，虾皮的鲜美与葱花的清香，搭配滑嫩的豆花，是早餐桌上的传统美味。',
    difficulty: '简单',
    prepTime: '30分钟',
    servings: '2人份',
    ingredients: [
      '黄豆 200g', '清水 1500ml', '内酯 3g', '虾皮 20g',
      '紫菜 5g', '葱花 20g', '生抽 15ml', '香油 5ml',
      '白胡椒粉 少许', '盐 适量',
    ],
    steps: [
      '制作基础豆花备用',
      '虾皮用温水泡软，沥干水分',
      '紫菜撕成小片',
      '小碗中混合生抽、香油、白胡椒粉调成酱汁',
      '将热豆花舀入碗中',
      '撒上虾皮、紫菜和葱花',
      '淋上调好的酱汁即可食用',
    ],
    tips: '虾皮提前泡软可以去除过重的咸味，紫菜最后放保持酥脆。',
  },
  {
    id: '7',
    slug: 'yuzi-niang-douhua',
    title: '芋泥波波豆花',
    category: 'tese-douhua',
    categoryName: '特色豆花',
    image: 'https://readdy.ai/api/search-image?query=Modern%20fusion%20tofu%20pudding%20douhua%20dessert%20with%20purple%20taro%20paste%2C%20boba%20pearls%2C%20and%20condensed%20milk%20in%20a%20trendy%20glass%20bowl%2C%20minimalist%20marble%20table%2C%20bright%20natural%20light%2C%20clean%20white%20background%2C%20popular%20dessert%20photography&width=800&height=600&seq=douhua-recipe-07&orientation=landscape',
    excerpt: '当绵密芋泥遇上Q弹波波，再搭配嫩滑豆花，三重口感层层递进，是当下最受欢迎的豆花新吃法。',
    difficulty: '中等',
    prepTime: '50分钟',
    servings: '2人份',
    ingredients: [
      '黄豆 200g', '清水 1500ml', '内酯 3g', '芋头 200g',
      '紫薯粉 5g', '波波珍珠 80g', '炼乳 30ml', '白砂糖 40g',
      '淡奶油 50ml',
    ],
    steps: [
      '制作基础豆花备用',
      '芋头去皮切块蒸熟，压成芋泥',
      '芋泥加入白砂糖、淡奶油和紫薯粉搅拌均匀',
      '波波珍珠按照包装说明煮熟，过冷水备用',
      '将豆花舀入碗中',
      '铺上厚厚一层芋泥',
      '撒上波波珍珠，淋上炼乳即可',
    ],
    tips: '芋泥过筛后口感更细腻，波波珍珠煮好后泡在糖水中防止粘连。',
  },
  {
    id: '8',
    slug: 'shuiguo-bingzhen-douhua',
    title: '缤纷水果冰豆花',
    category: 'bingzhen-douhua',
    categoryName: '冰镇豆花',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20chilled%20tofu%20pudding%20douhua%20dessert%20bowl%20topped%20with%20assorted%20fresh%20fruits%20strawberry%2C%20kiwi%2C%20blueberry%2C%20and%20mango%2C%20drizzled%20with%20honey%2C%20bright%20summer%20vibe%2C%20clean%20white%20background%2C%20fresh%20vibrant%20food%20photography&width=800&height=600&seq=douhua-recipe-08&orientation=landscape',
    excerpt: '满满一碗缤纷鲜果搭配冰爽豆花，色彩缤纷营养丰富，是颜值与健康兼具的夏日甜品。',
    difficulty: '简单',
    prepTime: '20分钟',
    servings: '2人份',
    ingredients: [
      '黄豆 200g', '清水 1500ml', '内酯 3g', '草莓 5颗',
      '蓝莓 30g', '奇异果 1个', '芒果 半个', '蜂蜜 30ml',
      '薄荷叶 少许',
    ],
    steps: [
      '制作基础豆花，冷藏2小时',
      '草莓洗净切半，奇异果去皮切片',
      '芒果去皮切丁，蓝莓洗净沥干',
      '将冰镇豆花舀入大碗中',
      '将各种水果精美摆放在豆花上',
      '淋上蜂蜜，点缀薄荷叶即可',
    ],
    tips: '水果可以根据季节更换，建议选择颜色丰富的水果让成品更加诱人。',
  },
];

export const brandFeatures = [
  {
    icon: 'ri-seedling-line',
    title: '精选非转基因黄豆',
    description: '严选优质非转基因黄豆，从源头保证每一碗豆花的纯正品质与健康安全。',
  },
  {
    icon: 'ri-time-line',
    title: '传统石磨工艺',
    description: '传承百年的石磨研磨技艺，低温慢磨保留大豆原始香气与营养成分。',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '零添加更健康',
    description: '坚持不添加防腐剂、人工色素，用天然食材呈现豆花最本真的味道。',
  },
  {
    icon: 'ri-goblet-line',
    title: '创新口味研发',
    description: '在传承经典的同时不断探索新口味，将传统豆花与现代美食完美融合。',
  },
];

export const testimonials = [
  {
    name: '张女士',
    location: '北京',
    rating: 5,
    comment: '自从发现了91豆花，我们全家都成了忠实粉丝！红糖姜汁豆花是我冬天的最爱，暖暖的很贴心。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20woman%20in%20her%2030s%2C%20warm%20friendly%20smile%2C%20simple%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20portrait%20photography&width=120&height=120&seq=avatar-01&orientation=squarish',
  },
  {
    name: '李先生',
    location: '上海',
    rating: 5,
    comment: '作为一个四川人，麻辣豆花真的让我找到了家乡的味道！豆花嫩滑，调味地道，强烈推荐。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20man%20in%20his%2030s%2C%20confident%20smile%2C%20simple%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20portrait%20photography&width=120&height=120&seq=avatar-02&orientation=squarish',
  },
  {
    name: '王小姐',
    location: '广州',
    rating: 5,
    comment: '抹茶红豆豆花简直是我的心头好！颜值高味道好，每次发朋友圈都能收获一堆赞。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20woman%20in%20her%2020s%2C%20bright%20smile%2C%20simple%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20portrait%20photography&width=120&height=120&seq=avatar-03&orientation=squarish',
  },
];

export const cultureCards = [
  {
    title: '豆花的前世今生',
    description: '豆花起源于汉代，相传为淮南王刘安在炼丹时偶然发现。两千多年来，豆花从宫廷美食走入寻常百姓家，演变为各地独具特色的传统小吃。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20traditional%20tofu%20making%20scene%20with%20stone%20mill%20and%20soy%20beans%2C%20historical%20vintage%20style%2C%20warm%20earthy%20tones%2C%20traditional%20Chinese%20kitchen%20setting%20with%20wooden%20tools%2C%20soft%20natural%20light%2C%20cultural%20heritage%20photography&width=600&height=400&seq=culture-01&orientation=landscape',
  },
  {
    title: '南北豆花大不同',
    description: '北方偏爱咸豆花，以卤汁、酱料调味；南方钟情甜豆花，以糖水、红豆相伴。一咸一甜间，折射出中国饮食文化的丰富多元。',
    image: 'https://readdy.ai/api/search-image?query=Split%20composition%20showing%20savory%20northern%20Chinese%20douhua%20versus%20sweet%20southern%20douhua%2C%20both%20in%20traditional%20bowls%2C%20warm%20atmospheric%20lighting%2C%20cultural%20food%20comparison%2C%20clean%20cream%20background&width=600&height=400&seq=culture-02&orientation=landscape',
  },
  {
    title: '匠心传承与创新',
    description: '91豆花在传承古法制豆花工艺的同时，不断融入现代美食理念，让这碗千年美味焕发新的生命力，走向更多人的餐桌。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20fusion%20Chinese%20tofu%20pudding%20dessert%20presentation%20with%20artistic%20plating%2C%20elegant%20ceramic%20bowls%2C%20fresh%20ingredients%20surrounding%2C%20bright%20airy%20kitchen%20setting%2C%20contemporary%20food%20photography%20with%20natural%20light&width=600&height=400&seq=culture-03&orientation=landscape',
  },
];

export const franchiseInfo = {
  title: '加入91豆花，共创甜蜜事业',
  description: '我们诚邀热爱传统美食、有志于餐饮创业的伙伴加入91豆花大家庭。总部提供全程开店支持，从选址装修到技术培训，让您轻松开启创业之路。',
  benefits: [
    '品牌授权与统一形象支持',
    '核心配方与技术培训',
    '选址评估与装修指导',
    '持续新品研发与供应',
    '线上线下营销推广支持',
  ],
  image: 'https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20modern%20Chinese%20dessert%20shop%20interior%20with%20wooden%20furniture%2C%20warm%20lighting%2C%20clean%20minimalist%20design%2C%20displaying%20various%20tofu%20pudding%20desserts%2C%20cozy%20atmosphere%2C%20professional%20food%20service%20setting&width=700&height=500&seq=franchise-01&orientation=landscape',
};

export const faqs = [
  {
    q: '豆花和豆腐脑有什么区别？',
    a: '豆花和豆腐脑本质上是同一种食物，区别主要在于凝固程度和地域称呼。北方多称"豆腐脑"，南方多称"豆花"。豆花通常比豆腐脑更嫩滑，含水量更高。',
  },
  {
    q: '豆花的保质期是多久？',
    a: '新鲜制作的豆花建议在4小时内食用完毕。如需保存，可放入冰箱冷藏，但不宜超过24小时，且食用前需重新加热。',
  },
  {
    q: '豆花适合哪些人群食用？',
    a: '豆花富含优质植物蛋白和钙质，老少皆宜。特别适合儿童、老人以及需要补充蛋白质的人群。痛风患者建议适量食用。',
  },
  {
    q: '91豆花的加盟条件是什么？',
    a: '我们欢迎有餐饮创业热情、认同品牌理念的合作伙伴。具体要求包括：具备一定的资金实力、合适的经营场地、以及良好的商业信誉。具体详情欢迎联系我们。',
  },
  {
    q: '豆花可以做成纯素版吗？',
    a: '当然可以！豆花本身就是纯素食品，由黄豆和水制成。我们的大部分甜豆花产品都是纯素的，咸豆花可根据需求调整配料。',
  },
];